// eslint-disable-next-line
import LetterJumble from "./container/LetterJumble"
// eslint-disable-next-line
import { actions, actions as letterJumbleContainerActions } from './actions'

export const NAME = 'GRID_SEARCH'
export const types = {
  GET_SUBSCRIPTION_REQUEST: `${NAME}/GET_SUBSCRIPTION_REQUEST`,
}

export const initialState = {
  gridSearchType: {},
  GRID_WIDTH: 15,
  GRIG_HEIGHT: 13,
  POINTS_PER_CLICK: 2.625,
  gameMatrix: [],
  autoHelp: {
    remainingForAutoHelp: 2,
    list: [],
    index: 0
  },
  leftToFind: 18,
  lettersToFind: [],
  currentRound: 0,
  points: 0,
  timeLeft: 60,
  countDown: 3,
  wrongAnswers: 0,
  exersizeState: "startScrean"
}

export function reducer(state = initialState, action) {
  switch (action.type) {
    case "PREEXERSIZE":
      return {
        ...state,
        exersizeState: "preexersize"
      };
    case "INCREMENT_COUNTDOWN":
      return {
        ...state,
        countDown: state.countDown - 1,
      };
    case "INCREMENT":
      return {
        ...state,
        timeLeft: state.timeLeft - 1
      }
    case "SET_INCREMENT_COUNT_DOWN":
      return {
        ...state,
        countDown: action.newCountDown
      }
    case "START_GAME":
      return {
        ...state,
        exersizeState: "gameStarted"
      }
    case "GENERATE_MATRIX":      
        return {
          ...state,
          leftToFind: action.leftToFind,
          gameMatrix: action.gameMatrix,
          lettersToFind: action.lettersToFind,
          gridSearchType: action.gridSearchType
        }
    case "CELL_CLICK": {
      return {
        ...state,
        gameMatrix: action.gameMatrix,
        points: action.points,
        wrongAnswers: action.wrongAnswers,
        timeLeft: action.timeLeft,
        exersizeState: action.exersizeState,
        leftToFind: action.leftToFind,
        lettersToFind: action.lettersToFind,
        leftToFind: action.leftToFind,
        autoHelp: action.autoHelp
      }
    }
    case "GAME_OVER": {
      return {
        ...state,
        exersizeState: 'gameOver'
      }
    }
    case "SHOW_GAME_OVER_SCREAN": {
      return {
        ...state,
        exersizeState: 'scoreScrean'
      }
    }
    case "NEW_ROUND": {
      return {
        ...state,
        currentRound: action.currentRound,
      }
    }
    case "SET_GRID_SEARCH_TYPE": {
      return {
        ...state,
        gridSearchType: action.gridSearchType,
        leftToFind: 18,
        POINTS_PER_CLICK: action.POINTS_PER_CLICK,
        autoHelp: action.autoHelp
      }
    }
    default:
      return { ...state }
  }
}
